// extracted by mini-css-extract-plugin
export var cardIcon = "_6j-4";
export var checkboxCard = "_6j-0";
export var checkboxCardSelected = "_6j-1";
export var disabled = "_6j-2";
export var outerBorder = "_6j-3";
export var spacerMedium = "_6j-7";
export var spacerSmall = "_6j-6";
export var spacerXsmall = "_6j-5";